import debug from "debug";
import plugin from '../../lib/plugin';

const MODULE_NAME = 'app.core/modules/transport';
const log = debug(MODULE_NAME);

class TransportElementsPlugin {

    constructor(element, options) {
        log('new instance', element, options);

        this.element = element;
        this.options = options;

        if (!this.options.to) {
            throw new Error('Missing `to` option which is a target element selector.');
        }

        this.$element = $(element);
        this.$parent = this.$element.parent();

        // fire off an intial transport.
        this.check() && this.transport();
        this.watch();
    }

    /**
     * Determine if media query rule applies to this instance.
     *
     * @returns Boolean
     * @memberof TransportElementPlugin
     */
    check () {
        const current = Foundation.MediaQuery.current;
        let result = false;

        if (this.options.at) {
            log(`checking. Currently: ${current}. watching for: ${this.options.at}`);
            result = current === this.options.at;

        } else if (this.options.atLeast) {
            log(`checking. Currently: ${current}. watching for atLeast: ${this.options.atLeast}`);
            result = Foundation.MediaQuery.atLeast(this.options.atLeast);

        }
        log(`checked. ${result ? 'transporting':'waiting'}`);
        return result;
    }

    /**
     * transport element to the target element.
     *
     * @memberof TransportElementPlugin
     */
    transport () {
        if (this.$element.parent().get(0) === this.$parent.get(0)){
            log(`transporting`);
            this.$element.appendTo(this.options.to);
        }
    }

    /**
     * Return element back to its original place in the dom.
     *
     * @memberof TransportElementPlugin
     */
    return () {
        if (this.$element.parent().get(0) !== this.$parent.get(0)){
            log('returning');
            this.$element.appendTo(this.$parent);
        }
    }

    /**
     * Watch for window resize events.
     *
     * @memberof TransportElementPlugin
     */
    watch () {
        log('watching');
        $(window).on('resize', () => {
            if (this.check()) {
                this.transport();
            } else {
                this.return();
            }
        });
    }

}

TransportElementsPlugin.DEFAULTS = {
    at: null, // media query name at which this behaviour takes effect. outside the element is moved back.
    atLeast: null, // minimum media query name at which this behaviour takes effect. outside the element is moved back.
    to: null // target selector
};

plugin('transportElements', TransportElementsPlugin);

export function exec () {
    $(document).ready( () => {
        log('binding');
        $("[data-transport-elements]").transportElements();
        log('bound');
    });
}




// WEBPACK FOOTER //
// ./project/client/src/core/modules/transport-elements/index.js